export default __webpack_public_path__ + "img/apply_btn_1-a53f6ea2.png";